module.exports = __webpack_public_path__ + "img/bootstrap.47eb3019.svg";